import React from "react";
import img1 from "../assets/cateloge/WhatsApp Image 2026-04-20 at 22.22.36.jpeg";
import img2 from "../assets/cateloge/WhatsApp Image 2026-04-20 at 22.22.37 (1).jpeg";
import img3 from "../assets/cateloge/WhatsApp Image 2026-04-20 at 22.22.40.jpeg";
import img4 from "../assets/cateloge/WhatsApp Image 2026-04-20 at 22.22.42 (2).jpeg";
import img5 from "../assets/cateloge/WhatsApp Image 2026-04-20 at 22.22.43.jpeg";
import img6 from "../assets/cateloge/WhatsApp Image 2026-04-20 at 22.22.45 (1).jpeg";

const INSTA_URL = "https://www.instagram.com/shivkumar_mangaldas_soni/";
const reels = [
  { src: img1, caption: "Antique Kundan bridal set" },
  { src: img2, caption: "Temple long haar" },
  { src: img3, caption: "Layered gold rani haar" },
  { src: img4, caption: "Grand bridal choker" },
  { src: img5, caption: "Heavy bridal ensemble" },
  { src: img6, caption: "Temple rani haar" },
];

export default function Reels() {
  return (
    <section
      id="reels"
      className="relative py-16 sm:py-20 md:py-24 bg-gradient-to-b from-white via-cream to-white overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-10 left-10 w-72 h-72 rounded-full bg-pink-500/10 blur-3xl" />
        <div className="absolute bottom-10 right-10 w-72 h-72 rounded-full bg-maroon/10 blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-5 sm:px-6 md:px-10">
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
          <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.35em] text-gold-dark font-semibold mb-4">
            <span className="h-px w-8 bg-gold" />
            Follow Our Journey
            <span className="h-px w-8 bg-gold" />
          </span>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl text-maroon font-bold leading-tight">
            Reels &{" "}
            <span className="gold-gradient-text">Instagram Feed</span>
          </h2>
          <p className="mt-4 sm:mt-5 text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed">
            Watch our latest designs come to life. Follow us on Instagram
            @shivkumar_mangaldas_soni for exclusive collections, behind-the-scenes
            artistry and daily inspiration.
          </p>

          <a
            href={INSTA_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-5 inline-flex items-center gap-2 bg-gradient-to-tr from-[#f09433] via-[#e6683c] via-[#dc2743] to-[#bc1888] text-white px-6 py-2.5 rounded-full font-semibold text-sm shadow-lg hover:shadow-xl hover:scale-105 transition-all"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
              <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
              <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
            </svg>
            Follow @shivkumar_mangaldas_soni
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-4">
          {reels.map((r, i) => (
            <a
              key={i}
              href={INSTA_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative block aspect-[9/16] rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl border-2 border-white transition-all duration-500 hover:-translate-y-1"
            >
              <img
                src={r.src}
                alt={r.caption}
                loading="lazy"
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
              />

              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />

              <div className="absolute top-3 right-3 w-8 h-8 rounded-full bg-white/20 backdrop-blur flex items-center justify-center text-white">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                  <polygon points="5 3 19 12 5 21 5 3" />
                </svg>
              </div>

              <div className="absolute top-3 left-3">
                <div className="flex items-center gap-1.5 bg-white/90 backdrop-blur px-2 py-1 rounded-full">
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#bc1888" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                  </svg>
                  <span className="text-[9px] font-bold text-maroon uppercase tracking-wider">
                    Reel
                  </span>
                </div>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-3">
                <p className="text-white text-[11px] sm:text-xs font-medium line-clamp-2">
                  {r.caption}
                </p>
                <p className="text-gold text-[10px] mt-1 font-semibold">
                  @shivkumar_mangaldas_soni
                </p>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href={INSTA_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-maroon font-semibold hover:text-gold-dark transition-colors text-sm sm:text-base"
          >
            View all reels on Instagram
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
}
